export const iconFontAwesomeHouseholdStairs = (
	<i className="fa-solid fa-stairs"></i>
);
